export enum ReviewsStatusEnum {
  Attempt,
  Confirmed,
  Ended,
}
